module.exports = __webpack_public_path__ + "img/pr-11.6571d3bd.png";